const viteEnv =
  (
    import.meta as ImportMeta & {
      env?: Record<string, string | undefined>
    }
  ).env ?? {}

declare const __HELM_API_URL__: string | undefined
declare const __HELM_BUILD__: string | undefined

const nodeEnv = (typeof process !== 'undefined' ? process.env : {}) as Record<
  string,
  string | undefined
>
const compiledHelmApiUrl = typeof __HELM_API_URL__ !== 'undefined' ? __HELM_API_URL__ : undefined

function normalizeApiUrl(value: string | undefined): string | undefined {
  const trimmed = value?.trim().replace(/\/+$/, '')
  if (!trimmed) return undefined

  try {
    const url = new URL(trimmed)
    if (!['http:', 'https:'].includes(url.protocol)) return undefined
    return url.toString().replace(/\/+$/, '')
  } catch {
    return undefined
  }
}

function resolveRuntimeApiUrlOverride(): string | undefined {
  if (typeof window === 'undefined') return undefined

  const host = window.location.hostname
  const isLocalHost = host === 'localhost' || host === '127.0.0.1'
  const isVercelHelmPreview = /^helmtarifixapp-git-[a-z0-9-]+-xtellar-works\.vercel\.app$/i.test(
    host,
  )
  if (!isLocalHost && !isVercelHelmPreview) return undefined

  const params = new URLSearchParams(window.location.search)
  const queryOverride = normalizeApiUrl(params.get('helm_api_url') ?? undefined)
  if (queryOverride) {
    if (isLocalHost || /^https:\/\/helm-api-pr-\d+\.xtellar\.app$/i.test(queryOverride)) {
      window.sessionStorage.setItem('helm.apiUrlOverride', queryOverride)
      return queryOverride
    }
  }

  const storedOverride = normalizeApiUrl(
    window.sessionStorage.getItem('helm.apiUrlOverride') ?? undefined,
  )
  if (
    storedOverride &&
    (isLocalHost || /^https:\/\/helm-api-pr-\d+\.xtellar\.app$/i.test(storedOverride))
  ) {
    return storedOverride
  }

  return undefined
}

export const API_BASE_URL =
  resolveRuntimeApiUrlOverride() ||
  normalizeApiUrl(compiledHelmApiUrl) ||
  viteEnv.VITE_API_URL ||
  viteEnv.NEXT_PUBLIC_API_URL ||
  nodeEnv.NEXT_PUBLIC_API_URL ||
  'http://localhost:4003'

/** The commit this Helm build came from, or 'local'. */
export const HELM_BUILD = typeof __HELM_BUILD__ !== 'undefined' ? __HELM_BUILD__ : 'local'
